import { getValue } from './getValue.js';
import { isValid } from './isValid.js';
import { showError } from './showError.js';
import * as Common from './common.js';



/**
*** 指定したオブジェクトに合わせてバリデーションする
*** @param {*} rules object
*** @param {*} values object
*** @param {*} addMethod object
*** @returns boolean
**/

export function validation( target )
{
  // value を取得して arg に追加する
  Validations.value = getValue( target );

  // 要素の name
  const elemName = Validations.value.name;

  // rules に含まれているものだけバリデーションする
  if( elemName in rules === false ) return true;

  // バリデーションの結果を取得（オブジェクトが返ってくる）
  const result = isValid( target );

  // 通常の name  OR group の name を取得する
  const checkName = Common.getName(group, elemName);

  // 要素が group に属しているか
  const inGroup = Common.getGroupProp(group, elemName);

  // バリデーションの結果の容れ物
  const validationResults = {
    [checkName] : [ result ]
  }

  // group に属していたら自身以外の要素をバリデートする
  if( inGroup ){
    // 属している
    const elem = Validations.group[inGroup].split(' ');
    elem.forEach( val => {
      if( elemName !== val ){
        Validations.value = getValue(vivaForm[val]);
        validationResults[checkName].push(isValid(vivaForm[val]));
      }
    });
  }

  // エラーメッセージの表示
  showError(target, validationResults);

}
